var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        header: false,
        backdrop: false,
        "ok-title": _vm.okButtonText,
        "cancel-title": "Palaa etusivulle"
      },
      on: { hide: _vm.handleSessionExceptionClose },
      model: {
        value: _vm.sessionException,
        callback: function($$v) {
          _vm.sessionException = $$v
        },
        expression: "sessionException"
      }
    },
    [_c("h3", { domProps: { textContent: _vm._s(_vm.exceptionTitle) } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }